import { useAuth } from './auth';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

interface ApiClient {
  token: string | null;
}

let client: ApiClient = { token: null };

// Set the active bearer token (updated by a small hook in the tree root).
export function setApiToken(token: string | null): void {
  client.token = token;
}

export async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  headers.set('Content-Type', 'application/json');
  if (client.token) headers.set('Authorization', `Bearer ${client.token}`);

  const res = await fetch(`${BASE}${path}`, { ...options, headers });
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const body = (await res.json()) as { message?: string; error?: string };
      message = body.message ?? body.error ?? message;
    } catch {
      // ignore
    }
    throw new ApiError(res.status, message);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

// Hook that keeps the module-level API token in sync with the auth session.
export function useApiTokenBinding(): void {
  const { token } = useAuth();
  setApiToken(token);
}
